export const createRandomBoolean = () => Math.random() > 0.5;
